import { render, staticRenderFns } from "./NonImmigrantVisaHomeTemplate.vue?vue&type=template&id=57df5bfd&scoped=true"
import script from "./NonImmigrantVisaHomeTemplate.vue?vue&type=script&lang=js"
export * from "./NonImmigrantVisaHomeTemplate.vue?vue&type=script&lang=js"
import style0 from "./NonImmigrantVisaHomeTemplate.vue?vue&type=style&index=0&id=57df5bfd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57df5bfd",
  null
  
)

export default component.exports